import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import theme from './theme';
import { Route, Routes } from 'react-router';
import Landing from './components/Landing';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        path=""
        element={
          <Landing />}
          />
    </Routes>
  );
};
function App() {
  return (
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
